import { render, staticRenderFns } from "./circle-loader.vue?vue&type=template&id=20ad05bf"
import script from "./circle-loader.vue?vue&type=script&lang=js"
export * from "./circle-loader.vue?vue&type=script&lang=js"
import style0 from "./circle-loader.vue?vue&type=style&index=0&id=20ad05bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports